export default "__VITE_ASSET__C1wlywwa__"